import React from 'react';
import {
    Alert,
    Card,
    Col,
    Container,
    Row,
} from 'react-bootstrap';

import useCompanyContext from '../hooks/useCompanyContext';

const RequireSpecificCompany = ({
    children,
    action = 'continue',
}) => {
    const {
        isAdmin,
        hasSpecificCompany,
    } = useCompanyContext();

    /**
     * 普通用户只有一个固定 companyID。
     * 普通用户不需要经过管理员的公司选择限制。
     */
    if (!isAdmin) {
        return children;
    }

    /**
     * 管理员已选择具体公司 UUID。
     */
    if (hasSpecificCompany) {
        return children;
    }

    /**
     * 管理员当前 companyID = 0，
     * 表示正在查看全部公司。
     *
     * 对创建、编辑和配置类页面进行阻止。
     */
    return (
        <Container
            fluid
            className="py-4"
        >
            <Row className="justify-content-center">
                <Col
                    xs={12}
                    lg={8}
                    xl={6}
                >
                    <Card className="shadow-sm">
                        <Card.Body className="p-4">
                            <Alert
                                variant="warning"
                                className="mb-0"
                            >
                                <Alert.Heading>
                                    Select a company
                                </Alert.Heading>

                                <p className="mb-2">
                                    You are currently viewing all companies.
                                </p>

                                <p className="mb-0">
                                    Please select a specific company from the
                                    company selector above to {action}.
                                </p>
                            </Alert>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default RequireSpecificCompany;